var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTickTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5714 64.9366C38.0835 65.4528 37.4179 65.7407 36.7264 65.7407C36.035 65.7407 35.3693 65.4528 34.8814 64.9366L20.1468 49.4371C18.6177 47.8288 18.6177 45.2209 20.1468 43.6157L21.9918 41.6747C23.5214 40.0665 25.9982 40.0665 27.5273 41.6747L36.7264 51.3504L61.5838 25.2062C63.1134 23.5979 65.5925 23.5979 67.1193 25.2062L68.9643 27.1472C70.4934 28.7554 70.4934 31.3628 68.9643 32.9685L38.5714 64.9366Z",
    fill: "#49CF8F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43,
    stroke: "#49CF8F",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickTransparent);
export default __webpack_public_path__ + "static/media/CircleTickTransparent.d9cb4451febf707b84b3e4a34d24107b.svg";
export { ForwardRef as ReactComponent };